import { css, cx } from 'styled-system/css';
import { button } from 'styled-system/recipes';

// functional/SliderControls without Chakra (imported by client islands only — it takes callbacks):
// Flex end/end + two icon-only v2 Buttons, variant sliderLight/sliderDark, ml 4 between them,
// opacity .3 + not-allowed when disabled. Arrows = images/icons/client-opinions/arrow-*.svg inline.

type Props = {
  onSlidePrev: () => void;
  onSlideNext: () => void;
  disablePrev?: boolean;
  disableNext?: boolean;
  variant?: 'dark' | 'light';
  className?: string;
};

const arrowClass = css({ display: 'inline-flex', alignSelf: 'center', flexShrink: 0 });
const enabledClass = css({ opacity: 1, cursor: 'pointer' });
const disabledClass = css({ opacity: 0.3, cursor: 'not-allowed' });

const ArrowLeft = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M3.828 6.99968H16V8.99968H3.828L9.192 14.3637L7.778 15.7777L0 7.99968L7.778 0.22168L9.192 1.63568L3.828 6.99968Z"
      fill="#5F2DD3"
    />
  </svg>
);

const ArrowRight = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M12.172 6.99968L6.808 1.63568L8.222 0.22168L16 7.99968L8.222 15.7777L6.808 14.3637L12.172 8.99968H0V6.99968H12.172Z"
      fill="#5F2DD3"
    />
  </svg>
);

export const SliderControls = ({ onSlidePrev, onSlideNext, disablePrev, disableNext, variant, className }: Props) => {
  const buttonClass = button({ variant: variant === 'dark' ? 'sliderDark' : 'sliderLight' });
  return (
    <div className={cx(css({ display: 'flex', justifyContent: 'flex-end', alignItems: 'end' }), className)}>
      <button
        type="button"
        aria-label="previous slide"
        onClick={onSlidePrev}
        disabled={disablePrev}
        className={cx(buttonClass, disablePrev ? disabledClass : enabledClass)}
      >
        <span className={arrowClass}>
          <ArrowLeft />
        </span>
      </button>
      <button
        type="button"
        aria-label="next slide"
        onClick={onSlideNext}
        disabled={disableNext}
        className={cx(buttonClass, css({ ml: 4 }), disableNext ? disabledClass : enabledClass)}
      >
        <span className={arrowClass}>
          <ArrowRight />
        </span>
      </button>
    </div>
  );
};
